import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { structures } from "../data/structuresData";
import { FaDoorOpen } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { HiArrowRight } from "react-icons/hi";
import { GRUPPO, revealSu, revealFoto, VISTA } from "../utils/motionPresets";

const Structures = () => {
  const { t } = useTranslation();

  return (
    <section id="structures" className="bg-lux-bg pt-6 pb-14 md:py-20 px-6 lg:px-10 anchor">
      {/* Header */}
      <div className="max-w-6xl mx-auto text-center mb-6 md:mb-16">
        <span className="text-lux-accent text-sm font-semibold tracking-widest uppercase">
          {t("structures.subtitle")}
        </span>
        <h2 className="text-lux-cream text-4xl md:text-5xl font-medium tracking-wide mt-3">
          {t("structures.ourRooms")}
        </h2>
        <div className="w-16 h-px bg-lux-accent mx-auto mt-6" />
      </div>

      {/* Structure Cards */}
      <div className="max-w-[90rem] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
        {structures.map((structure, index) => (
          <motion.div
            key={structure.id}
            className="overflow-hidden"
            variants={GRUPPO}
            custom={index}
            initial="nascosto"
            whileInView="visibile"
            viewport={VISTA}
          >
          <motion.div variants={revealSu}>
          <Link
            to={`/structures/${structure.id}`}
            className="group relative block overflow-hidden bg-lux-surface border border-[#c9a962]/30 hover:border-[#c9a962]/70 transition-all duration-500 hover:shadow-md hover:shadow-lux-accent/10"
          >
            {/* Image Container */}
            <div className="relative h-72 md:h-80 overflow-hidden">
              {/* Wrapper separato: lo zoom d'ingresso sta qui, cosi' l'hover
                  sull'immagine resta gestito dal CSS e i due non si annullano. */}
              <motion.div variants={revealFoto} className="w-full h-full">
                <img
                  src={structure.cardImage || structure.heroImage}
                  alt={structure.name}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </motion.div>
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />

              {/* Room Count Badge */}
              <div className="absolute top-4 right-4 bg-lux-surface px-3 py-1.5 rounded-sm flex items-center space-x-2 border border-lux-muted">
                <FaDoorOpen className="text-lux-accent w-4 h-4" />
                <span className="text-lux-cream text-sm font-medium">
                  {structure.rooms.length} Rooms
                </span>
              </div>
            </div>

            {/* Content */}
            <div className="relative z-10">
              <div className="bg-lux-surface group-hover:bg-[#211d17] p-7 transition-colors duration-300">
                <h3 className="cormorant text-lux-cream group-hover:text-white text-3xl font-medium tracking-wide mb-2 transition-colors duration-300">
                  {structure.name}
                </h3>

                <div className="flex items-center space-x-2 text-lux-cream/70 group-hover:text-white/70 transition-colors duration-300">
                  <IoLocationSharp className="text-lux-accent w-4 h-4 flex-shrink-0" />
                  <span className="text-sm">
                    {structure.address}, {structure.city}
                  </span>
                </div>

                {/* CTA */}
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-lux-muted group-hover:border-white/20 transition-colors duration-300">
                  <span className="text-lux-accent text-sm font-medium">
                    {t("common.viewDetails")}
                  </span>
                  <div className="w-10 h-10 rounded-full bg-lux-accent/10 flex items-center justify-center group-hover:bg-lux-accent transition-colors duration-300">
                    <HiArrowRight className="w-5 h-5 text-lux-accent group-hover:text-lux-bg transition-colors duration-300 group-hover:translate-x-0.5 transform" />
                  </div>
                </div>
              </div>
            </div>
          </Link>
          </motion.div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Structures;
